import { toast } from 'react-toastify'
import { Alert, Box, Button } from '@mui/material'
import { useMutation } from '@tanstack/react-query'
import { ChainProtocol, OperationType, Token } from '@archax/shared-types'
import DefaultForm from './DefaultForm'
import HederaForm from './HederaForm'
import { FormMode } from '../../../../api/types'
import { createOperation } from '../../../../api/operations'
import onApiError from '../../../../util/on-api-error'

type ChangeOwnerFormProps = {
  token: Token
  onCancel: () => void
  onSuccess: () => void
}
export function ChangeOwnerForm({ token, onCancel, onSuccess }: ChangeOwnerFormProps) {
  const {
    standard: {
      chain: { protocol },
    },
  } = token

  const hasTreasuryBalanceRestriction =
    protocol === ChainProtocol.Solana && BigInt(token.onChainData?.balance || '0') > BigInt(0)

  const { mutateAsync, isLoading } = useMutation(
    (operationData: Record<string, unknown>) => {
      return createOperation(OperationType.ChangeOwner, operationData, token.id)
    },
    {
      onSuccess: () => {
        toast.success('Change Owner request sent for approval')
        onSuccess()
      },
      onError: onApiError,
    },
  )

  const onSubmit = async (operationData: Record<string, unknown>) => {
    if (!isLoading) {
      return mutateAsync(operationData)
    }
  }

  if (hasTreasuryBalanceRestriction) {
    return (
      <Box display="flex" flexDirection="column" gap={2} p={2}>
        <Alert severity="error">
          Cannot change owner while the treasury balance is greater than zero.
          <br />
          Please transfer or burn all tokens before changing the owner.
        </Alert>
        <Box display="flex" justifyContent="center">
          <Button size="large" onClick={onCancel}>
            Close
          </Button>
        </Box>
      </Box>
    )
  }

  switch (protocol) {
    case ChainProtocol.Hedera:
      return <HederaForm mode={FormMode.Create} token={token} onCancel={onCancel} onSubmit={onSubmit} />
    default:
      return <DefaultForm mode={FormMode.Create} token={token} onCancel={onCancel} onSubmit={onSubmit} />
  }
}
